import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { MdSearch } from "react-icons/md";
import { BsPeopleFill } from "react-icons/bs";
import {
  IoTrashOutline,
  IoTrendingUpSharp,
  IoTrendingDownSharp,
} from "react-icons/io5";
import { FaCalendarPlus } from "react-icons/fa";
import { TbCoinRupeeFilled } from "react-icons/tb";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Rectangle,
  Legend,
  Pie,
  Cell,
  PieChart,
} from "recharts";
import {
  useItemsFilter,
  useUserDataFilter,
} from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import moment from "moment";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import CuSpinner from "../../common_component/component/CuSpinner";
import PatientDashboard from "../components/PatientDashboard";
const Dashboard = () => {
  const { role_id } = useCurrentRole();
  const [clinic] = useAtom(clinicAtom);
  const currentYear = new Date().getFullYear();
  const [tasks, setTasks] = useState([]);
  const [patientDataYear, setPatientDataYear] = useState("year");
  const [incomeInsightYear, setIncomeInsightYear] = useState("year");
  const [creditInsightYear, setCreditInsightYear] = useState("year");
  const COLORS = [
    "#E7267A",
    "#FF653B",
    "#F5CE03",
    "##3592FF",
    "#57D08B",
    "#9644FF",
    "#000000",
  ];

  const patientDataFilter = `?backend=True&clinic_id=${clinic?.id}&action=getGenderInsights&doctor_id=${role_id}&choice=${patientDataYear}`;

  const { data: patientData } = useUserDataFilter(
    ApiEndPoint.DASHBOARD,
    patientDataFilter,
    clinic && role_id ? true : false
  );

  const appointmentInsightFilter = `?action=getAppointmentInsight&backend=True&clinic_id=${clinic?.id}&doctor_id=${role_id}`;
  const { data: appointmentInsightData, isLoading: appointmentLoading } =
    useItemsFilter(
      ApiEndPoint.DASHBOARD,
      appointmentInsightFilter,
      role_id && clinic ? true : false
    );

  const patientQueueFilter = `?backend=True&clinic_id=${clinic?.id}&doctor_id=${role_id}&action=getPatientQueue`;
  const { data: patientQueueData, isLoading: patientQueueLoading } =
    useItemsFilter(
      ApiEndPoint.DASHBOARD,
      patientQueueFilter,
      role_id && clinic ? true : false
    );

  const mainIncomeInsightFilter = `?backend=True&clinic_id=${clinic.id}&action=getIncomeInsights&choice=days`;
  const { data: mainincomeInsightData, isLoading: incomeLoading } =
    useUserDataFilter(
      ApiEndPoint.DASHBOARD,
      mainIncomeInsightFilter,
      clinic && role_id ? true : false
    );

  // //("CONSOLE INCONE", mainincomeInsightData);

  const incomeInsightFilter = `?action=getIncomeInsights&backend=True&clinic_id=${clinic?.id}&doctor_id=${role_id}&choice=${incomeInsightYear}`;
  const { data: incomeInsightData } = useUserDataFilter(
    ApiEndPoint.DASHBOARD,
    incomeInsightFilter,
    clinic && role_id ? true : false
  );

  const featureConsumptionFilter = `?backend=True&clinic_id=${clinic?.id}&action=getFeatureConsumptionInsights&doctor_id=${role_id}&choice=${creditInsightYear}`;
  const { data: featureConsumptionData } = useUserDataFilter(
    ApiEndPoint.DASHBOARD,
    featureConsumptionFilter,
    clinic && role_id ? true : false
  );

  useEffect(() => {
    const savedTasks = localStorage.getItem("tasks");
    if (savedTasks) {
      setTasks(JSON.parse(savedTasks));
    }
  }, []);

  return (
    <div className="h-screen w-full p-4">
      <div className="md:flex hidden w-full h-[80px] border px-4 justify-between items-center">
        <div className="w-[406px] h-12 border rounded flex items-center gap-2 px-2">
          <input
            type="search"
            placeholder="Search"
            className="flex-1 px-2 h-full border-none outline-none"
          />
          <MdSearch size={23} />
        </div>
        <div className="text-xl font-bold text-[#3A3A3A]">
          {/* Thu 25 July, 5:30 PM */}
          {moment(new Date()).format("ddd DD MMMM, h:mm A")}
        </div>
        <div className="w-[190px] h-12 flex justify-end items-center gap-4">
          {/* <div className="flex items-center gap-2">
            <span>Add</span>
            <FaPlus />
          </div> */}
          {/* <div className="h-full w-12 border rounded-full"></div> */}
        </div>
      </div>
      <div className="w-full flex md:flex-row flex-col gap-4 mt-4">
        {/* first section */}
        <div className="flex-1 flex flex-col gap-4">
          <div className="w-full overflow-auto no-scrollbar">
            <div className="flex items-center gap-4">
              <div className="h-[189px] min-w-[240px] border rounded-md flex-1 flex flex-col">
                <div className="w-full h-[66px] border-b flex justify-between items-center px-4">
                  <BsPeopleFill color="#F5CE03" size={25} />
                  <div className="md:text-xl text-sm text-[#777777]">
                    Total Appointments
                  </div>
                </div>
                <div className="w-full flex flex-col justify-between flex-1 py-2 px-4">
                  <div className="font-bold text-[32px] md:text-[42px] mt-4">
                    {appointmentLoading ? (
                      <CuSpinner />
                    ) : (
                      appointmentInsightData?.total_appointments
                    )}
                  </div>
                  <div className="flex justify-between items-center">
                    <span>last 7 days</span>
                    <div
                      className={`flex font-bold items-center gap-2 ${appointmentInsightData?.percentage_change > 0 ? "text-[#57D08B]" : appointmentInsightData?.percentage_change < 0 ? "text-red-500" : "text-yellow-500"} `}
                    >
                      <span>
                        {appointmentInsightData?.percentage_change?.toFixed(2)}%
                      </span>
                      {appointmentInsightData?.percentage_change > 0 ? (
                        <IoTrendingUpSharp color="green" />
                      ) : appointmentInsightData?.percentage_change < 0 ? (
                        <IoTrendingDownSharp color="red" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-[189px] min-w-[280px] border rounded-md flex-1 flex flex-col">
                <div className="w-full h-[66px] border-b flex justify-between items-center px-4">
                  <FaCalendarPlus color="#9644FF" size={25} />
                  <div className="md:text-xl text-sm text-[#777777]">
                    Pending
                  </div>
                </div>
                <div className="w-full flex flex-col justify-between flex-1 py-2 px-4">
                  <div className="font-bold text-[32px] md:text-[42px] mt-4">
                    {appointmentLoading ? (
                      <CuSpinner />
                    ) : (
                      appointmentInsightData?.pending_appointments
                    )}
                  </div>
                  <div className="flex justify-between items-center">
                    <span>last 7 days</span>
                    <div
                      className={`flex font-bold items-center gap-2 ${appointmentInsightData?.pending_percentage_change > 0 ? "text-[#57D08B]" : appointmentInsightData?.pending_percentage_change < 0 ? "text-red-500" : "text-yellow-500"} `}
                    >
                      <span>
                        {appointmentInsightData?.pending_percentage_change?.toFixed(
                          2
                        )}
                        %
                      </span>
                      {appointmentInsightData?.pending_percentage_change > 0 ? (
                        <IoTrendingUpSharp color="green" />
                      ) : appointmentInsightData?.pending_percentage_change <
                        0 ? (
                        <IoTrendingDownSharp color="red" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-[189px] min-w-[280px] border rounded-md flex-1 flex flex-col">
                <div className="w-full h-[66px] border-b flex justify-between items-center px-4">
                  <TbCoinRupeeFilled color="#F5CE03" size={25} />
                  <div className="md:text-xl text-sm text-[#777777]">
                    Total Earnings
                  </div>
                </div>
                <div className="w-full flex flex-col justify-between flex-1 py-2 px-4">
                  {incomeLoading ? (
                    <CuSpinner />
                  ) : (
                    <>
                      <div className="font-bold text-[32px] md:text-[42px] mt-4">
                        ₹ {mainincomeInsightData?.overall_total_income}{" "}
                      </div>
                      <div className="flex justify-between items-center">
                        <span>last 7 days</span>
                        <div
                          className={`flex font-bold items-center gap-2 ${mainincomeInsightData?.percentage_change > 0 ? "text-[#57D08B]" : mainincomeInsightData?.percentage_change < 0 ? "text-red-500" : "text-yellow-500"} `}
                        >
                          <span>
                            {mainincomeInsightData?.percentage_change?.toFixed(
                              2
                            )}
                            %
                          </span>
                          {incomeInsightData?.percentage_change > 0 ? (
                            <IoTrendingUpSharp color="green" />
                          ) : mainincomeInsightData?.percentage_change < 0 ? (
                            <IoTrendingDownSharp color="red" />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* graph section */}
          <div className="w-full border rounded-md">
            <div className="h-[66px] w-full border px-4 flex justify-between items-center">
              <span className="text-xl font-bold">Patients Visit</span>
              <select
                value={patientDataYear}
                onChange={(e) => setPatientDataYear(e.target.value)}
              >
                <option value="year">This Year</option>
                <option value="month">This Month</option>
                <option value="week">This Week</option>
              </select>
            </div>
            <div className="h-[280px] w-full">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  // width={500}
                  // height={300}
                  data={patientData?.data}
                  margin={{
                    top: 5,
                    right: 10,
                    left: 5,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="time_period" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar
                    dataKey="male"
                    fill="#17A1FA"
                    activeBar={<Rectangle fill="#17A1FA" stroke="#17A1FA" />}
                  />
                  <Bar
                    dataKey="female"
                    fill="#57D08B"
                    activeBar={<Rectangle fill="#E7267A" stroke="#E7267A" />}
                  />
                  <Bar
                    dataKey="child"
                    fill="#000000"
                    activeBar={<Rectangle fill="#F5CE03" stroke="#F5CE03" />}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="w-full border rounded-md">
            <div className="h-[66px] w-full border px-4 flex justify-between items-center">
              <span className="text-xl font-bold">Earning</span>
              <select
                className="cursor-pointer"
                value={incomeInsightYear}
                onChange={(e) => setIncomeInsightYear(e.target.value)}
              >
                <option value="year">This Year</option>
                <option value="month">This Month</option>
                <option value="week">This Week</option>
              </select>
            </div>
            <div className="h-[85px] w-full flex items-center gap-2 px-4">
              Total :{" "}
              <span className="text-2xl">
                ₹ {incomeInsightData?.total_income}
              </span>
            </div>
            <div className="w-full overflow-auto no-scrollbar">
              <div className="h-[340px] min-w-[500px] w-full">
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart
                    data={incomeInsightData?.data}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time_period" />
                    <YAxis />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="income"
                      stroke="#57D08B66"
                      fill="#57D08B66"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>

        {/* 2nd section */}
        <div className="md:w-[436px] w-full flex flex-col gap-4">
          <div className="w-full max-h-[440px] border rounded-lg flex flex-col">
            <div className="h-[65px] flex items-center w-full border-b px-4 font-bold text-xl">
              Patient Queue
            </div>
            <div className="flex-1 overflow-auto">
              {patientQueueLoading ? (
                <span>Loading...</span>
              ) : (
                <>
                  {patientQueueData?.patient_queue?.length > 0 ? (
                    <>
                      {patientQueueData?.patient_queue?.map((item, i) => {
                        return (
                          <div className="w-full h-[65px] flex border-b justify-between items-center px-4">
                            <div className="flex items-center gap-4">
                              <div className="w-10 h-10 rounded-full border uppercase bg-[#82ca9d] font-bold flex justify-center items-center">
                                {item?.user_details?.full_name?.split("")[0]}
                              </div>
                              <div className="h-full text-[#4B4B4B]">
                                <div className="font-bold">
                                  {item?.user_details?.full_name}
                                </div>
                                <div>
                                  {item?.is_walk_in
                                    ? "In-clinic Appointment"
                                    : "Online"}
                                </div>
                              </div>
                            </div>
                            <div className="font-bold text-[#4B4B4B]">
                              {moment(item?.start_time).format("hh:mm A")}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      <div className="w-full h-[65px] flex border-b justify-between items-center px-4">
                        <span>No Data Available</span>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="w-full border pb-4 rounded-md">
            <div className="w-full h-[66px] flex justify-between items-center px-4">
              <span>Credit Usage</span>
              <select
                className="cursor-pointer"
                value={creditInsightYear}
                onChange={(e) => setCreditInsightYear(e.target.value)}
              >
                <option value="year">This Year</option>
                <option value="month">This Month</option>
                <option value="week">This Week</option>
              </select>
            </div>
            <div className="flex justify-center items-center">
              <div className="relative">
                <div class="absolute top-[43%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center font-bold text-2xl">
                  {featureConsumptionData?.total_credits_combined} <br />
                  Credits
                </div>
                <PieChart width={250} height={250}>
                  <Pie
                    data={featureConsumptionData?.data}
                    cx={120}
                    cy={100}
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="total_credits"
                  >
                    {featureConsumptionData?.data?.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                        display={entry?.total_credits}
                      />
                    ))}
                  </Pie>
                </PieChart>
              </div>
            </div>
            <div className="w-full flex flex-wrap px-4 gap-4">
              {featureConsumptionData?.data?.map((item, i) => {
                return (
                  <div
                    className="flex-1 border rounded-md h-[111px] p-4 flex flex-col justify-between"
                    key={i}
                  >
                    <div className="flex items-center gap-2">
                      <span
                        className="w-[14px] h-[14px] rounded-full border"
                        style={{
                          backgroundColor: COLORS[i % COLORS.length],
                        }}
                      ></span>
                      <div className="capitalize text-sm xl:text-base">
                        {item?.feature}
                      </div>
                    </div>
                    <div className="font-bold text-xl xl:text-2xl">
                      {item?.total_credits} Credits
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="h-[197px] w-full border rounded-md">
            <div className="h-[65px] px-4 border-b flex justify-between items-center">
              <span className="text-xl font-bold">Notes</span>
              <div className="flex items-center gap-4">
                <input type="checkbox" className="p-0 m-0" />
                <IoTrashOutline />
              </div>
            </div>
            <div className="w-full p-4 text-lg">
              <ul>
                {tasks?.map((item, i) => {
                  return <li key={i}>{item?.title}</li>;
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <PatientDashboard /> */}
    </div>
  );
};

export default Dashboard;
